module.exports = __webpack_public_path__ + "img/spacing-example-simple-details-1.2827e761.png";